var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPdfSectionCulture(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8 16.602H2.2a1.2 1.2 0 1 0 0 2.4h15.6a1.2 1.2 0 0 0 0-2.4ZM8.792 9.597v4.058a1.2 1.2 0 0 0 2.4 0V9.597a1.2 1.2 0 1 0-2.4 0ZM14.058 9.597v4.058a1.2 1.2 0 1 0 2.4 0V9.597a1.2 1.2 0 1 0-2.4 0ZM3.527 9.597v4.058a1.2 1.2 0 0 0 2.4 0V9.597a1.2 1.2 0 1 0-2.4 0ZM1.938 6.62h16.125A.937.937 0 0 0 19 5.681a.922.922 0 0 0-.51-.818l-.082-.037-7.718-3.675a1.643 1.643 0 0 0-1.38 0l-7.793 3.69a.952.952 0 0 0-.517.84.937.937 0 0 0 .938.937Z",
    fill: "#68686A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfSectionCulture);
export default __webpack_public_path__ + "static/media/pdfSectionCulture.7ec15e4476c73769f00d1ac8b4752dae.svg";
export { ForwardRef as ReactComponent };